<template>
  <div class="assets-transfer">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="top-navbar-left">
              <div class="btn-back" @click="$router.go(-1)">
                <font-awesome-icon :icon="['fas', 'angle-left']" />
                Back
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-center">Edit Announcement</div>
          </div>
        </div>
      </div>

      <hr />

      <div
        class="custom-alert alert alert-success"
        role="alert"
        v-if="isSuccess"
      >
        Announcement updated successfully.
      </div>
      <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
        Please fill in the mandatory field(s).
      </div>
    </div>

    <div class="container mt-5">
      <div>
        <div>
          <div class="row">
            <div class="col-md-6">
              <div
                class="form-group"
                :class="{ 'form-is-error': $v.announcement.title.$error }"
              >
                <label for="title">Announcement Title *</label>
                <input
                  class="form-control"
                  id="title"
                  type="text"
                  v-model="announcement.title"
                />

                <div
                  class="invalid-feedback form-error-msg"
                  v-if="!$v.announcement.title.required"
                >
                  Title is required
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{ 'form-is-error': $v.announcement.status.$error }"
              >
                <label>Status *</label>

                <div>
                  <div class="custom-control-inline pill-radio">
                    <input
                      type="radio"
                      id="active"
                      name="status"
                      value="0"
                      class="custom-control-input"
                      v-model="announcement.status"
                    />
                    <label class="" for="active">Active</label>
                  </div>
                  <div class="custom-control-inline pill-radio">
                    <input
                      type="radio"
                      id="inactive"
                      name="status"
                      value="1"
                      class="custom-control-input"
                      v-model="announcement.status"
                    />
                    <label class="" for="inactive">Inactive</label>
                  </div>
                </div>

                <div
                  class="invalid-feedback form-error-msg"
                  v-if="!$v.announcement.status.required"
                >
                  Status is required
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div
                class="form-group"
                :class="{
                  'form-is-error': $v.announcement.to_announce_at.$error,
                }"
              >
                <label>Announcement Date & Time *</label>

                <template>
                  <app-date-picker
                    v-model="announcement.to_announce_at"
                    :pickTime="true"
                    :format="'YYYY-MM-DD HH:mm'"
                    class="form-control"
                  ></app-date-picker>
                </template>
                <div
                  class="invalid-feedback form-error-msg"
                  v-if="!$v.announcement.to_announce_at.required"
                >
                  Date is required
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{
                  'form-is-error': $v.announcement.to_announce_at.$error,
                }"
              >
                <label>Target Users *</label>

                <div>
                  <div class="custom-control-inline pill-radio">
                    <input
                      type="checkbox"
                      id="ba"
                      value="BA"
                      class="custom-control-input"
                      v-model="announcement.target_user"
                    />
                    <label class="" for="ba">BA</label>
                  </div>
                  <div class="custom-control-inline pill-radio">
                    <input
                      type="checkbox"
                      id="tl"
                      value="TL"
                      class="custom-control-input"
                      v-model="announcement.target_user"
                    />
                    <label class="" for="tl">TL</label>
                  </div>
                </div>

                <div
                  class="invalid-feedback form-error-msg"
                  v-if="!$v.announcement.to_announce_at.required"
                >
                  Target users is required
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{ 'form-is-error': $v.announcement.division.$error }"
              >
                <label>Division *</label>

                <div>
                  <div class="custom-control-inline pill-radio">
                    <input
                      id="north"
                      type="checkbox"
                      value="0"
                      class="custom-control-input"
                      v-model="announcement.division"
                      @change="onChangeDivision()"
                    />
                    <label class="" for="north">North</label>
                  </div>
                  <div class="custom-control-inline pill-radio">
                    <input
                      id="south"
                      type="checkbox"
                      value="1"
                      class="custom-control-input"
                      v-model="announcement.division"
                      @change="onChangeDivision()"
                    />
                    <label class="" for="south">South</label>
                  </div>
                </div>

                <div
                  class="invalid-feedback form-error-msg"
                  v-if="!$v.announcement.division.required"
                >
                  Division is required
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{ 'form-is-error': $v.announcement.region.$error }"
              >
                <label>Region *</label>

                <app-multi-select
                  :options="
                    regionOptions.map((regionOption) => regionOption.id)
                  "
                  :custom-label="
                    (opt) => regionOptions.find((x) => x.id == opt).name
                  "
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :placeholder="'-- All Region --'"
                  v-model="announcement.region"
                  @input="onChangeRegion"
                >
                  <template
                    slot="selection"
                    slot-scope="{ values, search, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length &amp;&amp; !isOpen"
                      >{{ values.length }} selected</span
                    ></template
                  >
                </app-multi-select>

                <div
                  class="selected-label"
                  v-if="announcement.region.length > 0"
                >
                  SELECTED:
                  <div v-for="region in announcement.region" :key="region">
                    {{ regionOptions.find((x) => x.id == region).name }}
                  </div>
                </div>

                <div
                  class="invalid-feedback form-error-msg"
                  v-if="!$v.announcement.region.required"
                >
                  Region is required
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{ 'form-is-error': $v.announcement.area.$error }"
              >
                <label for="">Area *</label>

                <div
                  class="custom-modal-select"
                  :class="{ selected: announcement.area.length > 0 }"
                  v-b-modal.area-modal
                >
                  <input
                    type="button"
                    class="form-control"
                    :value="
                      announcement.area.length > 0
                        ? announcement.area.length + ' selected'
                        : '-- All Area --'
                    "
                  />
                </div>

                <div class="selected-label" v-if="announcement.area.length > 0">
                  SELECTED:
                  <div v-for="area in announcement.area" :key="area">
                    {{ areaOptions.find((x) => x.id == area).name }}
                  </div>
                </div>

                <div
                  class="invalid-feedback form-error-msg"
                  v-if="!$v.announcement.area.required"
                >
                  Area is required
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group mt-4"
            :class="{ 'form-is-error': $v.announcement.message.$error }"
          >
            <label>Announcement</label>

            <textarea
              rows="8"
              class="form-control"
              v-model="announcement.message"
            ></textarea>

            <div
              class="invalid-feedback form-error-msg"
              v-if="!$v.announcement.message.required"
            >
              Message is required
            </div>
          </div>
        </div>

        <button
          type="submit"
          class="mt-3 btn btn-ecdc btn-shadow"
          @click="checkForm"
        >
          Save
        </button>
        <button
          type="button"
          class="mt-3 btn btn-link"
          @click="$router.go(-1)"
        >
          Cancel
        </button>
      </div>
    </div>

    <b-modal id="area-modal" hide-header hide-footer centered size="xl">
      <img
        src="../assets/img/icon-close.png"
        alt="icon-close"
        class="img-fluid modal-close"
        @click="$bvModal.hide('area-modal')"
      />

      <div class="selection-modal">
        <h4 class="title text-left mb-5">Area</h4>

        <div class="form-group">
          <div class="row">
            <div
              v-for="area in areaOptions"
              v-bind:key="area.id"
              class="col-4 col-xl-2"
            >
              <div class="custom-control custom-checkbox form-check-inline">
                <input
                  class="custom-control-input"
                  type="checkbox"
                  :id="'inlineCheckbox' + area.id"
                  :value="area.id"
                  v-model="announcement.area"
                />
                <label
                  class="custom-control-label"
                  :for="'inlineCheckbox' + area.id"
                  >{{ area.name }}</label
                >
              </div>
            </div>
          </div>
        </div>

        <div>
          <button
            type="button"
            class="btn btn-ecdc"
            @click="$bvModal.hide('area-modal')"
          >
            Done
          </button>
          <button
            type="button"
            class="btn btn-link text-muted"
            @click="clearArea()"
          >
            Clear Selection
          </button>
        </div>
      </div>
    </b-modal>

    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<script>
import Loader from "./Loader.vue";
import DatePicker from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import {
  getAreas,
  getRegions,
  getAnnouncement,
  updateAnnouncement,
} from "../api";
import Multiselect from "vue-multiselect";
import { required, requiredIf } from "vuelidate/lib/validators";
import { getProj } from '../helpers/index'

export default {
  components: {
    appLoader: Loader,
    appDatePicker: DatePicker,
    appMultiSelect: Multiselect,
  },
  data() {
    return {
      id: "",
      announcement: {
        title: "",
        status: 0,
        to_announce_at: "",
        target_user: [],
        message: "",
        division: [],
        region: [],
        area: [],
        project_id: 2
      },
      regions: [],
      regionOptions: [],
      areas: [],
      areaOptions: [],
      isLoading: true,
      isError: false,
      isSuccess: false,
      toggleFilter: true,
    };
  },
  validations: {
    announcement: {
      title: {
        required,
      },
      status: {
        required,
      },
      to_announce_at: {
        required,
      },
      target_user: {
        required,
      },
      message: {
        required,
      },
      division: {
        required: requiredIf(function () {
          return this.isLocationEmpty;
        }),
      },
      region: {
        required: requiredIf(function () {
          return this.isLocationEmpty;
        }),
      },
      area: {
        required: requiredIf(function () {
          return this.isLocationEmpty;
        }),
      },
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.getRegions();
    await this.getAreas();
    await this.getAnnouncement();
    this.announcement.project_id = getProj().projId;
    this.isLoading = false;
  },
  computed: {
    isLocationEmpty() {
      return (
        !!this.announcement.division.length &&
        !!this.announcement.region.length &&
        !!this.announcement.area.length
      );
    },
  },
  methods: {
    checkForm() {
      const _this = this;
      this.$v.announcement.$touch();

      if (this.$v.announcement.$invalid) {
        this.isError = true;
        window.scrollTo(0, 0);

        setTimeout(function () {
          _this.isError = false;
        }, 2000);
      } else {
        this.saveAnnouncement();
      }
    },
    async getAnnouncement() {
      try {
        const result = await getAnnouncement(this.id);
        this.announcement = result.data.announcement;

        this.announcement.target_user = this.announcement.target_user.split(
          ","
        );

        this.initiateFilter();
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async saveAnnouncement() {
      let _this = this;
      this.isLoading = true;

      try {
        await updateAnnouncement({ announcement: this.announcement });
        this.isSuccess = true;

        window.scrollTo(0, 0);

        setTimeout(function () {
          _this.isSuccess = false;
          _this.$router.push({ name: "announcementsDetails" });
        }, 2000);
      } catch (err) {
        alert(err.response.data.message);
      }

      this.isLoading = false;
    },
    async getRegions() {
      try {
        const result = await getRegions();
        this.regions = result.data.data;
        this.regionOptions = this.regions;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getAreas() {
      try {
        const result = await getAreas();
        this.areas = result.data.data;
        this.areaOptions = this.areas;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    onChangeDivision() {
      const _this = this;
      this.regionOptions = [];
      this.announcement.region = [];
      this.areaOptions = this.areas;
      this.announcement.area = [];

      if (this.announcement.division.length > 0) {
        this.announcement.division.forEach((division) => {
          const found = _this.regions.filter(
            (value) => value.division == division
          );

          found.forEach((value) => {
            _this.regionOptions.push(value);
          });
        });
      } else {
        this.regionOptions = this.regions;
      }
    },
    onChangeRegion() {
      const _this = this;
      this.areaOptions = [];
      this.announcement.area = [];

      if (this.announcement.region.length > 0) {
        this.announcement.region.forEach((region) => {
          const found = _this.areas.filter(
            (value) => value.region_id == region
          );

          found.forEach((value) => {
            _this.areaOptions.push(value);
          });
        });
      } else {
        this.areaOptions = this.areas;
      }
    },
    clearArea() {
      this.announcement.area = [];
    },
    initiateFilter() {
      let _this = this;
      this.regionOptions = [];
      this.areaOptions = [];

      if (this.announcement.division.length > 0) {
        this.announcement.division.forEach((division) => {

          let found = _this.regions.filter(
            (value) => value.division == division
          );

          found.forEach((value) => {
            _this.regionOptions.push(value);
          });
        });
      }

      if (this.announcement.region.length > 0) {
        this.announcement.region.forEach((region) => {
          let found = _this.areas.filter((value) => value.region_id == region);

          found.forEach((value) => {
            _this.areaOptions.push(value);
          });
        });
      }
    },
  },
};
</script>
